module.exports = __webpack_public_path__ + "static/img/enlarge-circular-3.f02af0ee.png";